import { Target, Zap } from "lucide-react";

function getWeekStart() {
  const d = new Date();
  const day = d.getDay();
  const diff = day === 0 ? 6 : day - 1;
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

function getDaysLeft() {
  const now = new Date();
  const sun = new Date(now);
  const toSun = (7 - sun.getDay()) % 7 || 7;
  sun.setDate(sun.getDate() + toSun);
  sun.setHours(23, 59, 59, 0);
  return Math.ceil((sun - now) / (1000 * 60 * 60 * 24));
}

// Static mission config — backend will drive this when available
const MISSION = { goal: 2, reward: "+€3 cashback", label: "Faz 2 pedidos esta semana" };

export function PortalWeeklyMission({ orders }) {
  const weekStart = getWeekStart();
  const done = orders.filter(o =>
    new Date(o.created_at) >= weekStart && o.status !== "cancelled"
  ).length;
  const progress = Math.min(done, MISSION.goal);
  const pct = (progress / MISSION.goal) * 100;
  const complete = progress >= MISSION.goal;
  const daysLeft = getDaysLeft();

  return (
    <div className={`rounded-xl border p-4 transition-colors ${
      complete ? "bg-emerald-50 border-emerald-200" : "bg-white border-gray-200 shadow-sm"
    }`}>
      <div className="flex items-center gap-2 mb-2.5">
        <Target className={`w-4 h-4 ${complete ? "text-emerald-600" : "text-orange-500"}`} />
        <span className="text-xs font-bold uppercase tracking-wide text-gray-500">Misión semanal</span>
        {complete ? (
          <span className="ml-auto text-xs font-semibold text-emerald-600 bg-emerald-100 px-2 py-0.5 rounded-full">
            Completa ✓
          </span>
        ) : (
          <span className="ml-auto text-xs text-gray-400">
            {daysLeft} dia{daysLeft !== 1 ? "s" : ""} restante{daysLeft !== 1 ? "s" : ""}
          </span>
        )}
      </div>

      <p className="text-sm font-semibold text-gray-800 mb-3">{MISSION.label}</p>

      {/* Step circles */}
      <div className="flex gap-2 mb-3">
        {Array.from({ length: MISSION.goal }).map((_, i) => (
          <div
            key={i}
            className={`flex-1 py-2 rounded-xl flex items-center justify-center text-sm font-black transition-all ${
              i < progress
                ? complete ? "bg-emerald-500 text-white shadow-sm" : "bg-orange-400 text-white shadow-sm"
                : "bg-gray-100 text-gray-300"
            }`}
          >
            {i < progress ? "✓" : i + 1}
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">{progress} / {MISSION.goal} pedidos</span>
        <div className={`flex items-center gap-1 text-xs font-bold ${complete ? "text-emerald-600" : "text-orange-600"}`}>
          <Zap className="w-3.5 h-3.5" />{MISSION.reward}
        </div>
      </div>

      {complete && (
        <p className="text-xs text-emerald-600 mt-2 font-medium">
          🎉 ¡Enhorabuena! Tu bonus se añadirá automáticamente.
        </p>
      )}
    </div>
  );
}
